import React, { useContext } from 'react';

import { AppType } from '../../../../store/store';
import css from '../SetPlan.module.scss';
import { Plan } from '../index';
import { AnalyticsContext } from '../../../../ModularReduxAnalytics';
import DefaultInfinityPlan from '../Plans/DefaultInfinityPlan';
import { PlanPrices, SavingsRewards } from '../../../../utils/prices';

interface Props {
  app: AppType;
  plans: PlanPrices;
  savings: SavingsRewards;
  onInfoClicked: (plan: Plan) => void;
  onUpgradeClicked: (plan: Plan) => void;
  onExploreAllPlansClicked: () => void;
  onSkip: () => void;
  onBackClicked: () => void;
}

const DefaultInfinityPlanContainer = ({
  app,
  plans,
  savings,
  onInfoClicked,
  onExploreAllPlansClicked,
  onUpgradeClicked
}: Props) => {
  const { loading } = app;
  const { analytics } = useContext(AnalyticsContext);

  return (
    <>
      <div className={css.investDefaultInfinity}>
        <img src="/static/infinity.svg" alt="infinity plan" />
      </div>
      <h1 data-e2e="upgrade-plans-header">
        {'Get our best plan for 1-month free'}
      </h1>

      <DefaultInfinityPlan
        onInfoClicked={onInfoClicked}
        flatFees={plans}
        savings={savings}
        onLearnMoreClicked={(_, plan) => {
          onInfoClicked(plan);
        }}
        loading={loading}
        analytics={analytics}
        onUpgradeClicked={onUpgradeClicked}
        flowId={app.flowId ?? ''}
        onExploreAllPlansClicked={onExploreAllPlansClicked}
      />
      <div className={css.investFooter}>
        <p>
          <sup>1</sup>See Greenlight&apos;s Terms of Service for details on
          earnings limits and how to qualify. Subject to change at any time.
        </p>
        <p>
          <sup>2</sup>Requires mobile data or a WiFi connection, and access to
          sensory and motion data from cell phone to utilize family location
          sharing, SOS alerts and crash detection features. Messaging and data
          rates and other terms may apply.
        </p>
        <p>
          <sup>3</sup>Cell phone and purchase protection provided by Virginia
          Surety Company Inc. Cell phone protection is not available to
          residents of New York.
        </p>
        <p>
          By continuing, you are accepting Greenlight’s
          <a
            target="_blank"
            href={`https://greenlight.com/terms-of-service`}
            data-e2e="terms"
            rel="noreferrer"
          >
            Terms of Service
          </a>{' '}
          &{' '}
          <a
            target="_blank"
            href={`https://greenlight.com/privacy`}
            data-e2e="privacy-policy"
            rel="noreferrer"
          >
            Privacy Statement
          </a>
          .
        </p>
      </div>
    </>
  );
};

export default DefaultInfinityPlanContainer;
